import { createTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { muiColorsOverrideHandler } from './muiColorsOverrideHandler';

/** FE layout/responsive layer on top of admin-aligned base theme. */
export const muiThemeOverrideHandler = createTheme(muiColorsOverrideHandler, {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  spacing: (factor: number) => `${0.25 * factor}rem`,
  components: {
    // Responsive Container component defaults
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '16px',
          paddingRight: '16px',
          '@media (min-width:600px)': {
            paddingLeft: '24px',
            paddingRight: '24px',
          },
          '@media (min-width:900px)': {
            paddingLeft: '32px',
            paddingRight: '32px',
          },
        },
      },
    },
    // Responsive Grid spacing
    MuiGrid: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            '&.MuiGrid-container': {
              margin: '0',
              '& > .MuiGrid-item': {
                padding: '0 4px',
              },
            },
          },
        },
      },
    },
    // Responsive Dialog — match main content area (same as palette.background.default)
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme }: { theme: Theme }) => ({
          margin: '16px',
          width: 'calc(100% - 32px)',
          maxHeight: 'calc(100% - 32px)',
          backgroundColor: theme.palette.background.default,
          backgroundImage: 'none',
          border: `1px solid ${theme.palette.divider}`,
          '@media (min-width:600px)': {
            margin: '32px',
            width: 'calc(100% - 64px)',
            maxHeight: 'calc(100% - 64px)',
          },
        }),
      },
    },
  },
});
